import { getApiInst } from '~/atoms/MangoApi'

import {
  createExtensionsApi,
  createExtensionsApiFromHttp,
} from '@mangovoice/extensions-ui'

export const extensionsApi = createExtensionsApi(
  createExtensionsApiFromHttp(getApiInst().getHttpTransport()),
)
